import moment from "moment";

export class StatsService {
  constructor(API, Auth, TLVCache, ItCache) {
    'ngInject';

    this.API = API;
    this.Auth = Auth;
    this.TLVCache = TLVCache;
    this.ItCache = ItCache;
  }

  export(from, to, type, users, searchValue) {
    var params = {
      from: from,
      to: to,
      type: type
    };

    if (users) {
      params.userId = users;
    }

    if (searchValue && searchValue.length > 0) {
      params.searchValue = searchValue;
      params.language = localStorage.getItem("roedl-language").includes('de') ? 'de' : 'en';
    }

    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + `/worklog/report`,
      responseType: 'blob',
      params: params
    });
  }

  exportOvertimes(from, to, users, isManagement) {
    var params = {
      from: from,
      to: to
    };
    if (users) {
      params.userId = users;
    }
    const url = isManagement ? '/management/users/overtimes/report' : '/users/overtimes/report';
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + url,
      responseType: 'blob',
      params: params
    });
  }

  exportOvertimeEmployee(from, to, users) {
    var params = {
      from: from,
      to: to
    };
    if (users) {
      params.userId = users;
    }
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/user/overtimes/report',
      responseType: 'blob',
      params: params
    });
  }

  getWorklogs(from, to, update) {
    const date = from + " - " + to;
    return this.TLVCache.get(
      'worklogs',
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/worklog/team',
        params: {
          from: from,
          to: to,
          page: 0,
          page_size: 10000,
          cacheBuster: Math.random().toString().slice(2, 10)
        }
      }),
      date,
      update
    );
  }

  getWorklogsPU(from, to) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/worklog/team',
      params: {
        from: from,
        to: to,
        page: 0,
        page_size: 10000,
        cacheBuster: Math.random().toString().slice(2, 10)
      }
    });
  }

  acceptWorklog(worklog, isManagement) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/${isManagement ? 'management/' : ''}worklog/` + worklog.id,
      data: {
        approved: true
      }
    });
  }

  declineWorklog(worklog, isManagement) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + `/${isManagement ? 'management/' : ''}worklog/` + worklog.id
    });
  }

  formatDateInAFuckedUpWay(date) {
    return date.format("YYYY-MM-DD") + "T" + date.format("HH:mm:ss.SSS");
  }

  prepareWorklogRequest(worklog) {
    var worklogData = null;
    if (worklog.process) {
      var processWorklog = {
        type: "process",
        outputType: worklog.outputType,
        startedAt: this.formatDateInAFuckedUpWay(worklog.startedAtTime),
        processClientConfigurationId: worklog.process.id,
        clientId: worklog.client.id,
        problemId: undefined,
        valueAddedCorrection: worklog.valueAdded ? true : false,
        volume: worklog.process.hasVolume ? worklog.volume : undefined,
        comment: worklog.comment,
        invoiceDetails: worklog.invoiceDetails,
        projectId: worklog.project && worklog.project.id || worklog.projectId || undefined,
        billingTypeId: worklog.billingTypeId
      };
      worklogData = processWorklog;
    }

    if (worklog.interrupt) {
      var interruptWorklog = {
        type: "interrupt",
        startedAt: this.formatDateInAFuckedUpWay(worklog.startedAtTime),
        interruptId: worklog.interrupt.id,
        clientId: worklog.client && worklog.client.id || null,
        serviceLine: worklog.serviceLine || null,
        comment: worklog.comment,
        invoiceDetails: worklog.invoiceDetails,
        valueAddedCorrection: worklog.valueAdded ? true : false,
        projectId: worklog.project && worklog.project.id || worklog.projectId || undefined,
        billingTypeId: worklog.billingTypeId
      };
      worklogData = interruptWorklog;
    }

    worklogData.clientMultiselectKeywords = worklog.clientMultiselectKeywords;

    const oldDuration = worklog.duration || moment.duration();
    const durationDelta = moment.duration(worklog.newDuration.asMilliseconds() - oldDuration.asMilliseconds());
    const previousFinishedAt = worklog.finishedAtTime || worklog.startedAtTime;
    const startedAtTimeDelta = moment.duration(worklog.startedAtTime).subtract(moment.duration(worklog.oldStartedAtTime));

    /* ONLY USED IN EDITION*/
    worklogData.finishedAt = this.formatDateInAFuckedUpWay(previousFinishedAt.clone().add(durationDelta).add(startedAtTimeDelta));

    /* ONLY USED IN CREATION*/
    worklogData.duration = worklog.newDuration.toString();

    if (worklog.output)
      worklogData.outputType = worklog.output;

    if (worklog.overtimeApplicationId)
      worklogData.overtimeApplicationId = worklog.overtimeApplicationId;

    if (typeof worklog.splitOvertimeApplicationWorklog === 'boolean')
      worklogData.splitOvertimeApplicationWorklog = worklog.splitOvertimeApplicationWorklog;

    if (worklog.billingTypeId && worklog.billingTypeId !== "")
      worklogData.billingTypeId;

    return worklogData;
  }

  saveWorklog(worklog, isManagement) {
    var worklogData = this.prepareWorklogRequest(worklog);
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/${isManagement ? 'management/' : ''}worklog/` + worklog.id,
      data: worklogData
    });
  }

  saveWorklogValidation(worklog, isManagement) {
    var worklogData = this.prepareWorklogRequest(worklog);

    if (worklogData.overtimeApplicationId)
      worklogData.splitOvertimeApplicationWorklog = true;

    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + `/${isManagement ? 'management/' : ''}worklog/validation/` + worklog.id,
      data: worklogData
    });
  }

  createWorklog(worklog, user, isManagement) {
    var worklogData = this.prepareWorklogRequest(worklog);
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/${isManagement ? 'management/' : ''}worklog/forUser/` + user.id,
      data: worklogData
    });
  }

  createWorklogValidations(worklog, user, isManagement) {
    var worklogData = this.prepareWorklogRequest(worklog);

    if (worklogData.overtimeApplicationId)
      worklogData.splitOvertimeApplicationWorklog = true;

    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/${isManagement ? 'management/' : ''}worklog/validation/forUser/` + user.id,
      data: worklogData
    });
  }

  safeCreateWorklog(worklog) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/worklog/forUser/' + worklog.userId,
      data: {
        ...worklog,
        startedAt: this.formatDateInAFuckedUpWay(worklog.startedAtTime),
        finishedAt: this.formatDateInAFuckedUpWay(worklog.finishedAtTime)
      }
    });
  }

  safeSaveWorklog(worklog) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: this.API.root + '/worklog/' + worklog.id,
      data: {
        ...worklog,
        startedAt: this.formatDateInAFuckedUpWay(worklog.startedAtTime),
        finishedAt: this.formatDateInAFuckedUpWay(worklog.finishedAtTime)
      }
    });
  }

  getSummary(from, to, type) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/worklog',
      params: {
        from: from,
        to: to,
        type: type,
        cacheBuster: Math.random().toString().slice(2, 10)
      }
    });
  }

  getPowerUser(from) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/is-power-user?month=' + from
    });
  }

  getTeam() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/team'
    });
  }

  getDailyReport(from, to) {
    var params = {};
    if (from) {
      params.from = from;
    }
    if (to) {
      params.to = to;
    }
    const date = from + " - " + to;
    return this.TLVCache.get(
      'daily',
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/team/daily-report',
        params: params
      }),
      date,
      true
    );
  }

  getProfitabilityReport(from, to) {
    const date = from + " - " + to;
    return this.TLVCache.get(
      'profitability',
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/team/profitability-report',
        params: { from, to }
      }),
      date
    );
  }

  getProfitabilityOvertimesReport(from, to) {
    const date = from + " - " + to;
    return this.TLVCache.get(
      'profitability-overtime',
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/team/profitability-report-overtimes',
        params: { from, to }
      }),
      date
    );
  }

  refreshCurrencyConversions() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/currencies'
    });
  }

  getSubordinateTeams() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/teams/subordinate'
    });
  }

  getSubordinateIncome() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/teams/subordinate-income'
    });
  }

  getProfitabilityReportManager(from, to, teams) {
    const date = from + " - " + to;
    const uId = `profitability-manager-${teams.join('_')}`;
    return this.TLVCache.get(
      uId,
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/team/profitability-report',
        params: {
          from,
          to,
          teamId: teams
        }
      }), date);
  }

  getProfitabilitySettings() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/profitability/settings'
    });
  }

  putProfitabilitySettings(data) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/profitability/settings',
      data: data
    });
  }

  getProfitabilityOvertimesReportManager(from, to, teams) {
    const date = from + " - " + to;
    const uId = `profitability-overtime-manager-${teams.join('_')}`;
    return this.TLVCache.get(
      uId,
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/team/profitability-report-overtimes',
        params: {
          from,
          to,
          teamId: teams
        }
      }),
      date
    );
  }

  getProfitabilityEmployeesOvertimesReportManager(from, to, teams) {
    const date = from + " - " + to;
    const uId = `profitability-overtime-employees-manager-${teams.join('_')}`;
    return this.TLVCache.get(
      uId,
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/team/profitability-report-employee-overtimes',
        params: {
          from,
          to,
          teamId: teams
        }
      }),
      date
    );
  }

  getOvertimes(from, to, update) {
    const date = from + " - " + to;
    return this.TLVCache.get(
      'overtimes',
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/users/overtimes',
        params: {
          from,
          to
        }
      }),
      date,
      update
    );
  }

  getOvertimesForManager(from, to, update) {
    const date = from + " - " + to;
    return this.TLVCache.get(
      'mvOvertimes',
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/management/users/overtimes',
        params: {
          from,
          to
        }
      }),
      date,
      update
    );
  }

  getOvertimesEmployeeView(from, to, update) {
    const date = from + " - " + to;
    return this.TLVCache.get(
      'overtimes',
      () => this.Auth.httpWithAuthToken({
        method: 'GET',
        url: this.API.root + '/user/overtimes',
        params: {
          from,
          to
        }
      }),
      date,
      update
    );
  }

  editOvertime(overtime) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/users/overtimes',
      data: overtime
    });
  }

  editOvertimeAsManager(overtime) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/management/users/overtimes',
      data: overtime
    });
  }

  getVacationProcesses() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/vacation/data'
    });
  }

  getVacation(from, to) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/vacation',
      params: {
        from,
        to,
        newVacation: true
      }
    });
  }

  getPosition() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/position',
    });
  }

  addNewVacation(data) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/vacation',
      data
    });
  }

  deleteVacation(from, to) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: this.API.root + '/vacation?from=' + from + '&to=' + to
    });
  }

  getUserMonthlySummary(yearMonth) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/user-monthly-summary',
      params: {
        yearMonth
      }
    });
  }

  getPowerUserStatus() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/power-user-status'
    });
  }

  changeTeamLeaderGlobalPreferences(name, data) {
    return this.Auth.getPreferences().then((preferences) => {
      var newPreferences = angular.copy(preferences);
      newPreferences[name] = data;
      return this.Auth.patchPreferences(newPreferences);
    }).catch(()=>{
      return Promise.reject("failed get preferences");
    });
  }

  changePvTeamLeaderPreferences(tables, param, isParam) {
    return this.Auth.getPreferences().then((preferences) => {
      var newPreferences = angular.copy(preferences);
      var pvTeamLeaderTables = preferences.pvTeamLeaderTables || [];
      tables.forEach(table => {
        var newPvTeamLeaderTable = { table };
        newPvTeamLeaderTable[param] = isParam;
        var doesTableExist = pvTeamLeaderTables.find((t) => t.table == table);
        if (doesTableExist) {
          newPreferences.pvTeamLeaderTables.find((t) => t.table == table)[param] = isParam;
        } else {
          newPreferences.pvTeamLeaderTables = pvTeamLeaderTables.concat([newPvTeamLeaderTable]);
        }
      });
      return this.Auth.patchPreferences(newPreferences);
    });
  }

  changePvManagerPreferences(tables, param, isParam) {
    return this.Auth.getPreferences().then((preferences) => {
      var newPreferences = angular.copy(preferences);
      var pvManagerTables = preferences.pvManagerTables || [];
      tables.forEach(table => {
        var newPvManagerTable = { table };
        newPvManagerTable[param] = isParam;
        var doesTableExist = pvManagerTables.find((t) => t.table == table);
        if (doesTableExist) {
          newPreferences.pvManagerTables.find((t) => t.table == table)[param] = isParam;
        } else {
          newPreferences.pvManagerTables = pvManagerTables.concat([newPvManagerTable]);
        }
      });
      return this.Auth.patchPreferences(newPreferences);
    });
  }

  getClientGroupSheet(from, to, teamIds, clientGroupId, currencyRate) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/team/profitability-report-client-group-sheet`,
      params: {
        from,
        to,
        clientGroupId: clientGroupId,
        teamId: teamIds,
        currencyRate: currencyRate
      },
      responseType: 'blob'
    });
  }

  getClientGroupSheetTL(from, to, clientGroupId, currencyRate) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/team/profitability-report-client-group-sheet-tl`,
      params: {
        from,
        to,
        clientGroupId: clientGroupId,
        currencyRate: currencyRate
      },
      responseType: 'blob'
    });
  }

  getClientSheet(from, to, teamIds, clientId, currencyRate) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/team/profitability-report-client-sheet`,
      params: {
        from,
        to,
        clientId: clientId,
        teamId: teamIds,
        currencyRate: currencyRate
      },
      responseType: 'blob'
    });
  }

  getClientSheetTL(from, to, clientId, currencyRate) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/team/profitability-report-client-sheet-tl`,
      params: {
        from,
        to,
        clientId: clientId,
        currencyRate: currencyRate
      },
      responseType: 'blob'
    });
  }

  getTeamSheet(from, to, teamId, currencyRate) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/team/profitability-report-team-sheet`,
      params: {
        from,
        to,
        teamId: teamId,
        currencyRate: currencyRate
      },
      responseType: 'blob'
    });
  }

  getAnnualSetOffsData(id, isManagementView) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/${isManagementView ? 'management/' : ''}users/overtime-annuals?userId=` + id,
    });
  }

  getAnnualSetOffsDataEmployee(id) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/user/overtime-annuals?userId=` + id,
    });
  }

  createSettlementView(id, isManagementView) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/${isManagementView ? 'management/' : ''}users/` + id + `/overtime-settlement-template`,
    });
  }

  editSettlementView(id, canEdit, isManagementView) {
    let urlPath;

    if (isManagementView) {
      urlPath = `${this.API.root}/management/users/overtime-settlements/` + id;
    } else if (canEdit) {
      urlPath = `${this.API.root}/users/overtime-settlements/` + id;
    } else {
      urlPath = `${this.API.root}/user/overtime-settlements/` + id;
    }

    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: urlPath
    });
  }

  getOvertimeSettlements(id, isManagementView) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/${isManagementView ? 'management/' : ''}users/` + id + `/overtime-settlements`,
    });
  }

  getOvertimeSettlementsUser() {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/user/overtime-settlements`,
    });
  }

  saveSettlement(id, data, isManagement) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: `${this.API.root}/${isManagement ? 'management/' : ''}users/` + id + `/overtime-settlement`,
      data: data
    });
  }

  saveAnnualSetOff(data, isManagement) {
    return this.Auth.httpWithAuthToken({
      method: 'PUT',
      url: `${this.API.root}/${isManagement ? 'management/' : ''}users/overtime-annuals`,
      data: data
    });
  }

  saveEditSettlement(id, data, isManagement) {
    return this.Auth.httpWithAuthToken({
      method: 'PATCH',
      url: `${this.API.root}/${isManagement ? 'management/' : ''}users/overtime-settlements/` + id,
      data: data
    });
  }

  deleteSettlement(id, isManagement) {
    return this.Auth.httpWithAuthToken({
      method: 'DELETE',
      url: `${this.API.root}/${isManagement ? 'management/' : ''}users/overtime-settlements/` + id,
    });
  }

  getUsersForVaction(params) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: `${this.API.root}/vacation/users`,
      params
    });
  }

  getWorklogsForManager(from, to) {
    return this.Auth.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/management/worklogs',
      params: {
        from: from,
        to: to
      }
    });
  }

  getUsersChangelogs(from, to) {
    return this.ItCache.get(
      "MV_changelogs",
      () =>
        this.Auth.httpWithAuthToken({
          method: 'GET',
          url: this.API.root + '/teams/subordinate/users/changelogs',
          params: {
            from: from,
            to: to
          }
        }),
      24 * 60 * 60 * 1000
    );
  }

  getUserWorkspace(userId, date) {
    return this.ItCache.get(
      `MV/TLV_userWorkspace_${userId}_${date}`,
      () =>
        this.Auth.httpWithAuthToken({
          method: 'GET',
          url: this.API.root + `/management/users/${userId}/workspace`,
          params: {
            workspaceAt: date
          }
        }),
      60 * 60 * 1000
    );
  }

  synchronizeWorklogsStatuses(ids) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/d365/sync/worklogs-statuses',
      data: {worklogId: ids}
    });
  }

  resendWorklogToD365(id) {
    return this.Auth.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + `/d365/send/worklog/${id}`
    });
  }

  getClientReport(params) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + '/team/profitability/client/report',
      responseType: 'blob',
      params
    });
  }

  getClientGroupsReport(params) {
    return this.Auth.httpWithAuthToken({
      url: this.API.root + '/team/profitability/client-group/report',
      responseType: 'blob',
      params
    });
  }
}
